module.exports = __webpack_public_path__ + "static/media/allie28.5d3d9a27.jpg";